export default "__VITE_ASSET__COvb9u$d__"